import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { AsyncKbNav } from '@atlassian/jira-horizontal-nav-jsm-knowledge-base/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { knowledgeHubLandingRoute } from '@atlassian/jira-router-routes-servicedesk-knowledge-hub-routes/src/knowledgeHubLandingRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { projectIdResource } from '@atlassian/jira-router-resources-knowledge-hub/src/services/project-id/index.tsx';
import { kbTopicsResource } from '@atlassian/jira-router-resources-knowledge-hub/src/services/kb-topics/index.tsx';
import { knowledgeHubBrowseAllArticlesKBTypeCheckerResource } from '@atlassian/jira-router-resources-knowledge-hub/src/services/kb-type-checker/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getKnowledgeHubResources } from './common/getKnowledgeHubResources.tsx';
import ServiceDeskKnowledgeHubLandingPage, {
	LazyServicedeskKnowledgeHubLanding,
} from './ui/landing-page/index.tsx';

export const knowledgeHubLandingRouteEntry = createEntry(knowledgeHubLandingRoute, () => ({
	group: 'servicedesk',
	component: ServiceDeskKnowledgeHubLandingPage,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
		horizontal: AsyncKbNav,
		// TODO: Remove this during jira_nav4 cleanup
		onlyShowHorizontalOnNav4: true,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getKnowledgeHubResources(),
		getConsolidationStateResource(),
		resourceWithCondition2(() => fg('jsm-kb-articles-functional'), projectIdResource),
		resourceWithCondition2(() => fg('jsm-kb-articles-functional'), kbTopicsResource),
		resourceWithCondition2(
			() => fg('jsm-kb-articles-functional'),
			knowledgeHubBrowseAllArticlesKBTypeCheckerResource,
		),
	],

	forPaint: [LazyAtlassianNavigation, LazyServicedeskKnowledgeHubLanding],

	meta: {
		reporting: {
			id: APP_NAMES.KB_LANDING,
			packageName: toPackageName(APP_NAMES.KB_LANDING),
			teamName: 'jsm-nebula',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubLandingRouteEntry.tsx',
			whichExportToUse: 'knowledgeHubLandingRouteEntry',
		},

		enabled: true,
	},
}));
